import axios from "axios";
import {errorHandler} from "@/services/errorHandler";
import * as XLSX from "xlsx";

export default {
    name: "transactionManager",
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        getTransactions(context, payload) {
            let {from, to} = context.getters.getGlobalDateRange;

            // Ensure dates are strings (fix for object dates)
            if (from && typeof from === 'object') from = from._year + '-' + String(from._month).padStart(2, '0') + '-' + String(from._day).padStart(2, '0');
            if (to && typeof to === 'object') to = to._year + '-' + String(to._month).padStart(2, '0') + '-' + String(to._day).padStart(2, '0');

            if(!payload.status){
                payload.status = true;
            }
            console.log(payload);
            return axios.get(`${ChickenLittle}report/getTransactionHistory?apiKey=${payload.apikey}&approved=${payload.status}&from=${from}&to=${to}`)
            .then(({data}) => data)
                .catch(err => errorHandler.tomcatError(err) )
        },
        async downloadExcel(context, payload) {
            // Payload should contain { columns: Array, rows: Array }
            const { columns, rows } = payload;

            console.log("Received columns for Excel:", columns);
            console.log("Received rows for Excel:", rows ? rows.length : 0);

            // --- Input Validation ---
            if (!columns || !Array.isArray(columns) || columns.length === 0) {
                console.error("downloadExcel action error: 'columns' array is missing or empty in payload.");
                throw new Error("Cannot generate Excel: Column definitions are missing."); // Throw error to be caught by component
            }
            if (!rows || !Array.isArray(rows)) {
                console.error("downloadExcel action error: 'rows' array is missing or not an array in payload.");
                throw new Error("Cannot generate Excel: Data is missing."); // Throw error
            }
            if (rows.length === 0) {
                console.warn("downloadExcel action: No data rows provided to export.");
                alert("No data available to export to Excel."); // Inform user directly
                return; // Stop execution if no rows
            }

            try {
                // --- Dynamic Excel Generation ---

                // 1. Extract Headers (Labels) from the columns array
                const headers = columns.map(col => col.label); // Use the label for the header
                const fields = columns.map(col => col.field);   // Use the field for data mapping

                // 2. Process the rows: Create data matching the exact order and fields of the columns
                const processedData = rows.map(row => {
                    const newRow = {};
                    // Iterate through the *fields* derived from the columns payload
                    fields.forEach(field => {
                        // Use the field name to get data from the row, default to empty string if missing
                        newRow[field] = row.hasOwnProperty(field) ? (row[field] ?? '') : '';
                    });
                    return newRow;
                });

                // 3. Generate worksheet using the processed data
                //    We provide the data as an array of objects where keys match the 'fields'
                //    Then, we use `aoa_to_sheet` to precisely control headers and data order.
                const wsData = [
                    headers, // First row is the headers
                    ...processedData.map(row => fields.map(field => row[field])) // Subsequent rows are data arrays matching field order
                ];
                const worksheet = XLSX.utils.aoa_to_sheet(wsData);


                // 4. Auto-width calculation based on headers and processed data
                const columnWidths = headers.map((header, i) => {
                    const field = fields[i]; // Get the corresponding field name
                    const maxLength = Math.max(
                        header.length, // Header length
                        ...processedData.map(row => {
                            const cellValue = row[field]; // Access data using the field name
                            return cellValue != null ? String(cellValue).length : 0;
                        })
                    );
                    return { wch: maxLength + 2 }; // Add padding
                });
                worksheet['!cols'] = columnWidths;


                // 5. Create workbook and append worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions"); // Sheet name

                // 6. Define filename and trigger download
                //    Generate a timestamp for a unique filename
                const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
                const filename = `transactions_export_${timestamp}.xlsx`;
                XLSX.writeFile(workbook, filename);

                console.log("Excel file generated and download triggered:", filename);

                // --- End Dynamic Excel Generation ---

            } catch (error) {
                console.error('Error generating Excel file in Vuex action:', error);
                // Throw the error again so the component's .catch() can handle it
                throw new Error(`Failed to generate Excel report: ${error.message || 'Unknown error'}`);
            }
            // No finally block needed here unless there's specific cleanup
        },
        getPaymentLink(context, payload) {
            if (!payload){
                payload = 'true'
            }
            console.log("testing");
        }
    }
}
